module.exports = __webpack_public_path__ + "static/EL_BIL merke-499a78d48f3678ac34f739b9e015b9c5.png";